import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../../contexts/AuthContext'
import { useAuthModal } from '../../../contexts/AuthModalContext'

/**
 * "Plan My Trip" always means "take me to my dashboard." Signed in, that's a
 * direct client-side navigation. Signed out, it opens the in-page auth
 * modal with /dashboard as the post-auth destination -- the modal itself
 * navigates there once AuthModalContext's handleAuthenticated confirms a
 * real session, so this hook only has to say where, not how.
 *
 * `href` is left `undefined` when signed out rather than pointing at a real
 * signin URL, matching how the rest of the app already treats sign-in
 * (Navbar's "Sign In" is a plain onClick button, not a real anchor) — so a
 * signed-out "open in new tab" behaves the same here as everywhere else in
 * the app, not worse.
 */
export function usePlanTripCta() {
  const { isAuthenticated } = useAuth()
  const { open: openAuthModal } = useAuthModal()
  const navigate = useNavigate()

  const handleClick = (e) => {
    e.preventDefault()
    if (isAuthenticated) {
      navigate('/dashboard')
    } else {
      openAuthModal({ returnTo: '/dashboard' })
    }
  }

  return {
    href: isAuthenticated ? '/dashboard' : undefined,
    onClick: handleClick,
  }
}
